import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Auth from './views/Auth.vue'
import Admin from './views/Admin.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: { title: 'Главная' }
    },
    {
      path: '/auth',
      name: 'auth',
      component: Auth,
      meta: { title: 'Авторизация' }
    },
    {
      path: '/admin',
      name: 'admin',
      component: Admin,
      meta: { title: 'Админ' }
    },
    {
      path: '/admissions',
      name: 'admissions',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "admissions" */ './views/Admissions.vue'),
      meta: { title: 'Заявки' }
    },
    {
      path: '/specialties',
      name: 'specialties',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "specialties" */ './views/Specialties.vue'),
      meta: { title: 'Специальности' }
    },
    {
      path: '/news',
      name: 'news',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "news" */ './views/News.vue'),
      meta: { title: 'Новости' }
    },
    {
      path: '/rules',
      name: 'rules',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "rules" */ './views/Rules.vue'),
      meta: { title: 'Правила приема' }
    },
    {
      path: '/preparatory',
      name: 'preparatory',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "preparatory" */ './views/Preparatory.vue'),
      meta: { title: 'Подготовительные курсы' }
    }
  ]
})
